import React from 'react';
import classnames from 'classnames';
import styles from './AppHeader.mod.scss';

export default function AppHeader({
  cartOpen,
  isScrollingDown,
  headerRef,
  children
}) {
  return (
    <div
      className={classnames(styles.appHeader, {
        [styles.appHeaderCartOpen]: cartOpen,
        [styles.appHeaderScrollingDown]: isScrollingDown
      })}
      ref={headerRef}
    >
      {children}
    </div>
  );
}
